import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TUpdatePushToCardWorkerRequestSchema,
  TUpdatePushToCardWorkerResponseSchema,
} from "./updatePushToCardWorker.schema";

export const updatePushToCardWorker =
  (axios: IAxiosInstance) =>
  async (body: TUpdatePushToCardWorkerRequestSchema) => {
    const response = await axios.noRetry.patch<
      IApiResponse<TUpdatePushToCardWorkerResponseSchema>
    >(`/api/push-to-card/worker`, body);
    return response.data;
  };
